import template from './template.html'
export default angular.module('ft.components.shoppinglist.empty-state', [
  'ionic',
])
.component('shlEmptyState', {
  template,
})
.name
